import React, { Component } from 'react'
import { CHAT_PATH } from '@hlj/hlj-constant'
import { encrypt } from '@core/utils'

export default class extends Component {
  toChat = e => {
    e.stopPropagation()
    const newWindow = window.open('', '_blank')
    let path = CHAT_PATH

    if (this.props.toUserId) {
      path += `?to_user_id=${encrypt(this.props.toUserId)}`
    }

    newWindow.location.href = path
  }

  render() {
    return this.props.toUserId ? (
      <a
        onClick={e => this.toChat(e)}
        style={{ verticalAlign: 'middle', ...this.props.style }}
      >
        {this.props.children || (
          <img src="http://qnm.hunliji.com/o_1bktkth9gi8c18c6o661j5k19nd7.jpg" />
        )}
      </a>
    ) : null
  }
}
